export default function TimeCalculator(start, end) {
  const eventStartDate = new Date("2023-09-15");
  const eventEndDate = new Date("2023-09-17");
  const timeDifference = eventEndDate - eventStartDate;
  const hoursDifference = timeDifference / (1000 * 60 * 60);

  return hoursDifference;
}
